(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var top=document.querySelector('.xp-share--top'), head=document.querySelector('article.article .section-header');
    if(top&&head){head.parentNode.insertBefore(top,head.nextSibling);}
    var bot=document.querySelector('.xp-share--bottom'), body=document.querySelector('article.article .article__body');
    var foot=document.querySelector('.xp-print-foot');
    if(bot&&body){body.parentNode.insertBefore(bot,body.nextSibling); if(foot){bot.parentNode.insertBefore(foot,bot.nextSibling);}}
    var ph=document.querySelector('.xp-print-head'), art=document.querySelector('article.article');
    if(ph&&art){art.insertBefore(ph,art.firstChild);}
    document.querySelectorAll('[data-xp-copy]').forEach(function(b){
      b.addEventListener('click',function(){
        var url=b.getAttribute('data-xp-copy'), t=b.getAttribute('data-xp-title');
        if(navigator.share&&window.matchMedia('(max-width:749px)').matches){navigator.share({title:t,url:url}).catch(function(){});return;}
        var lab=b.querySelector('[data-xp-copy-label]');
        (navigator.clipboard?navigator.clipboard.writeText(url):Promise.reject()).then(function(){lab.textContent='Copied';setTimeout(function(){lab.textContent='Copy link';},2000);}).catch(function(){window.prompt('Copy this link:',url);});
      });
    });
    function prep(){
      document.querySelectorAll('details').forEach(function(d){d.setAttribute('open','');});
      document.querySelectorAll('img[data-src]').forEach(function(i){var s=i.getAttribute('data-src');if(s&&s.indexOf('{width}')>-1){s=s.replace('{width}','1080');}if(s){i.src=s;}i.classList.add('lazyloaded');});
      document.querySelectorAll('img[loading="lazy"]').forEach(function(i){i.loading='eager';});
    }
    window.addEventListener('beforeprint',prep);
    document.querySelectorAll('[data-xp-print]').forEach(function(b){b.addEventListener('click',function(){prep();setTimeout(function(){window.print();},400);});});
  });
})();
